
import { Button } from 'ant-design-vue';
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  components: {
    aButton: Button,
  },
  props: {},
  setup() {
    const router = useRouter();
    const goBack = () => {
      const { role, code } = sessionStorage;
      if (!role || !code) {
        router.push('/');
      } else if (role === 'student') {
        router.push('/Student/home');
      } else if (['admin', 'teacher'].includes(role)) {
        router.push('/Teacher/userlist');
      } else {
        router.push('/');
      }
    };
    return {
      goBack,
    };
  },
});
